import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { useMenu } from '../../hooks/useMenu';
import OnBoardingContainer from '../../components/OnBoarding/OnBoardingContainer';
import { HeadingSubtitle } from '../../components/Heading';
import themeColors from '../../assets/styles/themeColors';
import { selectSettings } from '../../store/selectors/settingsSelectors';
import IDDetailsForm from '../../components/Forms/IDDetailsForm';

const SecureAccountVerification = ({ applicantType, onModalClose }) => {
  const { activeMenu, activeItem } = useMenu();
  const { t } = useTranslation();
  const { BrokerName } = useSelector(selectSettings);
  const formId = 'id_details_form';
  const [eventType, setEventType] = useState(null);

  // const { backStep } = useGtmStepTracker({
  //   currentPath: 'Identity Information',
  //   previousPath: activeItem?.previousPath || '',
  // });

  return (
    <OnBoardingContainer
      activeMenu={activeMenu}
      activeItem={activeItem}
      previousPath={activeItem?.previousPath}
      formId={formId}
      //   setEventType={setEventType}
    >
      <Helmet>
        <title>
          {t('titleTagIdentityVerification', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <HeadingSubtitle mb={12} color={themeColors.colorTextSecondary}>
        {t('secureIdentityDetails.title')}
      </HeadingSubtitle>
      <IDDetailsForm
        nextPath={activeItem?.nextPath}
        applicantType={applicantType}
        onModalClose={onModalClose}
        eventType={eventType}
        setEventType={setEventType}
        formId={formId}
      />
    </OnBoardingContainer>
  );
};

SecureAccountVerification.propTypes = {
  applicantType: PropTypes.string,
  onModalClose: PropTypes.func,
};

export default SecureAccountVerification;
